export default "__VITE_ASSET__D50I7DUy__"